import apiFetch from '../apiFetch'

export default function (archivo, token) {
	archivo=archivo.archivo
	return apiFetch({endPoint: `FichaVerraco/obtenerArchivo`, method: 'POST', body: {archivo}, token: token})
}
